import { IEventBus } from "./IEventBus";
var emitter: any = require('tiny-emitter/instance');

export class TinyEmitterEventBus implements IEventBus {
    emit(event: string, ...args: any[]): IEventBus {
        emitter.emit(event, ...args);
        return this;
    }
    off(event?: string | string[] | undefined, callback?: Function | undefined): IEventBus {
        emitter.off(event, callback);
        return this;
    }

    on(event: string | string[], callback: Function): IEventBus {
        emitter.on(event, callback);
        return this;
    }

    once(event: string | string[], callback: Function): IEventBus {
        emitter.once(event, callback);
        return this;
    }
}
